import { distance } from "@turf/distance";
import { feature } from "@turf/helpers";
import type { Point, Polygon } from "geojson";
import type { EpaOperatorNotification } from "../../../apiClient/generated";
import { customDistanceToPolygon } from "../../../utils/geopatialUtils";

export const computeNearestSite = (notification: EpaOperatorNotification) => {
    // Calculate distance
    let distanceToSite: number = null;
    let site = notification.nearestSite;
    const emissionLocation = notification.dataPoint?.location;
    // This should not happen, but it did, so adding a safeguard.
    if (!emissionLocation) {
        return { site: null, distance: null };
    }

    // If there's only one site.
    if (site && (site.location || site.shape)) {
        if (site.shape) {
            distanceToSite = customDistanceToPolygon(
                site.shape as Polygon,
                feature(emissionLocation as Point),
            );
        } else if (site.location) {
            distanceToSite = distance(
                emissionLocation as Point,
                site.location as Point,
                {
                    units: "meters",
                },
            );
        }
    }
    // If there's multiple sites, find closest.
    else if (
        notification.otherNearSites &&
        notification.otherNearSites.length > 0
    ) {
        for (const nearbySite of notification.otherNearSites) {
            let d: number = null;
            if (nearbySite.shape) {
                d = customDistanceToPolygon(
                    nearbySite.shape as Polygon,
                    feature(emissionLocation as Point),
                );
            } else if (nearbySite.location) {
                d = distance(
                    emissionLocation as Point,
                    nearbySite.location as Point,
                    {
                        units: "meters",
                    },
                );
            }
            if (distanceToSite === null || distanceToSite >= d) {
                distanceToSite = d;
                site = nearbySite;
            }
        }
    }

    return {
        site,
        distance: distanceToSite,
    };
};
